import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any, arg: any): any {
    const resultPosts = [];
    
    for(const post of value){

        if(post.folioOperacion.indexOf(arg) > -1 || post.nombre.indexOf(arg) > -1 || post.apellido_paterno.indexOf(arg) > -1 || post.apellido_materno.indexOf(arg) > -1 ) {
         resultPosts.push(post);
      };
    };
    return resultPosts;
  }

}